import styled from "styled-components";

export const Wrapper = styled.div`
  padding:10px 16px ;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
   }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`

export const Card = styled.div`
  width: 100%;
  max-width: 1200px;
  opacity: 1;
  gap: 24px;
  border-radius: 24px;
  padding: 48px;
  background-color: var(--color-0a1323);
  display: flex;
  flex-direction: column;

  h4{
    font-weight: 700;
    font-style: Bold;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1px;
    text-align: center;

    @media (min-width: 850px){
      font-weight: 700;
      font-style: Bold;
      font-size: 40px;
      line-height: 48px;
      letter-spacing: 2px;
      text-align: center;
    }

    br{
      @media (min-width: 850px){
        display: none;
      }
    }
  }

`

export const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 190px;
  max-width: 269px;
  min-height: 40px;
  margin: 0 auto;
  border-radius: 8px;
  border-width: 1px;
  padding: 8px 16px;
  gap: 8px;
  opacity: 1;
  font-weight: 600;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  background-image: linear-gradient(var(--color-A62AFF), var(--color-A62AFF)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: 1px solid transparent;

  @media (min-width: 850px){
    width: 269px;
    height: 64px;
  }

  &:hover{
      background-image: linear-gradient(var(--color-3F145E), var(--color-3F145E)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
    } 
`

export const SectionShadow = styled.div`
  display: none;
  width: 100%;
  height: 73px;
  border-radius: 999px;

  /* mesmo glow (radial) */
  background: radial-gradient(
    60% 180% at 50% 105%,
    rgba(189, 14, 118, 0.70) 0%,
    rgba(124, 0, 67, 0.45) 28%,
    rgba(67, 0, 36, 0.18) 52%,
    rgba(0, 0, 0, 0) 82%
  );

  /* difusão */
  filter: blur(35px);
  opacity: 0.92;

  /* 🔥 deixa VISÍVEL só uma FAIXA fina na parte de BAIXO */
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 10%,
    #000 100%,
    #000 92%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    transparent 10%,
    #000 100%,
    #000 92%,
    transparent 100%
  );

  @media (min-width: 768px) {
    display: block;
  }

`;




